<template>
    <div class="row" v-if="hasAccountBalanceValue && !isFTC">
        <label class="row__label">
            {{ $getLocale('recurly_account_balance') }}
        </label>

        <div class="row__info">
            <span>
                {{ accountBalance }}
            </span>
        </div>
    </div>
    <div class="payment-summary__two-col" v-else-if="hasAccountBalanceValue && isFTC">
        <div class="col">
            {{ $getLocale('recurly_account_balance') }}
        </div>
        <div class="col">
            <div class="payment-summary__first-payment-gap">
                {{ accountBalance }}
            </div>
        </div>
    </div>
</template>

<script>
    import BaseAccount from 'aa/vue/components/account/BaseAccount/BaseAccount';
    import billingInfoMixin from 'aa/vue/components/account/billingInfoMixin';
    import currentSubscriptionMixin from 'aa/vue/components/account/currentSubscriptionMixin';
    import { mapState } from 'vuex';

    export default {
        extends: BaseAccount,
        name: 'AccountBalance',
        mixins: [billingInfoMixin, currentSubscriptionMixin],
        props: {
            content: {
                type: Object,
            },
            isFTC: {
                type: Boolean,
                default: false,
            },
            pageAttr: {
                type: Object,
            },
        },
        data: function () {
            return {
                accountBalance: null,
            };
        },
        computed: {
            ...mapState('payment', {
                recurly: (state) => state.recurly,
            }),
            hasAccountBalanceValue() {
                return this.accountBalance !== null;
            },
        },
        methods: {
            getInternationalizedPricesUsingRecurly(balance) {
                if (this.recurly) {
                    const { currencySymbol, currencyCode } = this.recurly.Pricing.Subscription();
                    if (this.isFTC) {
                        const decimalPlaces = this.billingInfo.currency_subunits
                            ? Math.log10(this.billingInfo.currency_subunits)
                            : 2;
                        return `${currencySymbol}${balance?.toFixed(decimalPlaces)}`;
                    }
                    return `${currencySymbol}${balance} ${currencyCode}`;
                }
                return balance;
            },
            setAccountBalance() {
                if (this.billingInfo.currency_subunits) {
                    this.accountBalance = this.getInternationalizedPricesUsingRecurly(
                        this.billingInfo.recurlyAccountBalance.value /
                            this.billingInfo.currency_subunits,
                    );
                }
            },
        },
        watch: {
            recurly(newVal) {
                if (newVal) {
                    this.setAccountBalance();
                }
            },
        },
        mounted() {
            if (this.recurly) {
                this.setAccountBalance();
            }
        },
    };
</script>
